/* eslint-disable react-hooks/rules-of-hooks */
import { useCallback } from 'react';
// ChangeEventをuseCallbackでラップして返却するカスタムフック
export const useChangeEvent = () => {
    // Material-UIのTextField
    const changeText = useCallback((update) => {
        return useCallback((event) => update(event.target.value), [update]);
    }, []);
    // Material-UIのSelect(string)
    const changeStrSelect = useCallback((update) => {
        return useCallback((event) => update(event.target.value), [update]);
    }, []);
    // Material-UIのSelect(number)
    const changeNumSelect = useCallback((update) => {
        return useCallback((event) => update(event.target.value), [update]);
    }, []);
    // Material-UIのRadioButton
    const changeRadio = useCallback((update) => {
        return useCallback((event) => update(event.target.value), [update]);
    }, []);
    return { changeText, changeStrSelect, changeNumSelect, changeRadio };
};
